<template>
  <div class="admin-container">
    <div class="admin-header">
      <h1>后台管理系统</h1>
      <div class="admin-user">
        <span>admin</span>
        <button class="btn-logout" @click="logout">注销登录</button>
      </div>
    </div>

    <div class="admin-body">
      <!-- 左侧菜单 -->
      <div class="admin-sidebar">
        <el-menu
          default-active="dashboard"
          class="el-menu-vertical-demo"
          @select="handleMenuSelect"
          background-color="#0b0e17"
          text-color="#ccc"
          active-text-color="#00e6ac"
        >
          <el-menu-item index="dashboard">
            <i class="el-icon-s-home"></i>
            <span>仪表盘</span>
          </el-menu-item>

          <el-submenu index="site">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span>网站设置</span>
            </template>
            <el-menu-item index="site-basic">基本设置</el-menu-item>
            <el-menu-item index="site-seo">SEO设置</el-menu-item>
          </el-submenu>

          <el-submenu index="model">
            <template slot="title">
              <i class="el-icon-s-marketing"></i>
              <span>模型管理</span>
            </template>
            <el-menu-item index="model-category">模型分类</el-menu-item>
            <el-menu-item index="model-list">模型列表</el-menu-item>
          </el-submenu>

          <el-submenu index="member">
            <template slot="title">
              <i class="el-icon-s-custom"></i>
              <span>用户管理</span>
            </template>
            <el-menu-item index="member-list">用户列表</el-menu-item>
          </el-submenu>

          <el-submenu index="subscription">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>订阅管理</span>
            </template>
            <el-menu-item index="subscription-config">订阅方案</el-menu-item>
            <el-menu-item index="order-list">订单列表</el-menu-item>
          </el-submenu>

          <el-submenu index="generate">
            <template slot="title">
              <i class="el-icon-s-operation"></i>
              <span>生成设置</span>
            </template>
            <el-menu-item index="text-config">文案创作</el-menu-item>
            <el-menu-item index="generate-image">图像创作</el-menu-item>
            <el-menu-item index="generate-video">视频创作</el-menu-item>
            <el-menu-item index="drama-config">短剧创作</el-menu-item>
            <el-menu-item index="aspect-ratio-config">比例选项</el-menu-item>
          </el-submenu>
          
          <el-menu-item index="generate-history">
            <i class="el-icon-s-data"></i>
            <span>生成记录</span>
          </el-menu-item>

          <el-submenu index="payment">
            <template slot="title">
              <i class="el-icon-s-finance"></i>
              <span>支付设置</span>
            </template>
            <el-menu-item index="payment-alipay">支付宝</el-menu-item>
            <el-menu-item index="payment-wechat">微信支付</el-menu-item>
            <el-menu-item index="payment-union">云闪付</el-menu-item>
          </el-submenu>

          <el-submenu index="attachment">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span>附件设置</span>
            </template>
            <el-menu-item index="attachment-storage">存储设置</el-menu-item>
            <el-menu-item index="attachment-download">龙虾下载</el-menu-item>
            <el-menu-item index="attachment-email">邮件设置</el-menu-item>
          </el-submenu>

          <el-submenu index="system">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>系统设置</span>
            </template>
            <el-menu-item index="ad-setting">广告设置</el-menu-item>
          </el-submenu>

          <el-submenu index="admin">
            <template slot="title">
              <i class="el-icon-s-check"></i>
              <span>管理员设置</span>
            </template>
            <el-menu-item index="admin-add">添加管理员</el-menu-item>
            <el-menu-item index="admin-permission">权限设置</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>

      <!-- 右侧内容 -->
      <div class="admin-content">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  methods: {
    handleMenuSelect(key) {
      // 处理菜单选择
      console.log('Selected menu:', key)

      // 路由跳转
      const routeMap = {
        'dashboard': '/admin',
        'site-basic': '/admin/site-basic',
        'site-seo': '/admin/site-seo',
        'model-category': '/admin/model-category',
        'model-list': '/admin/model-list',
        'member-list': '/admin/member-list',
        'member-level': '/admin/member-level',
        'text-config': '/admin/text-config',
        'generate-image': '/admin/generate-image',
        'generate-video': '/admin/generate-video',
        'drama-config': '/admin/drama-config',
        'aspect-ratio-config': '/admin/aspect-ratio-config',
        'payment-alipay': '/admin/payment-alipay',
        'payment-wechat': '/admin/payment-wechat',
        'payment-union': '/admin/payment-union',
        'payment-guide': '/admin/payment-guide',
        'subscription-config': '/admin/subscription-config',
        'order-list': '/admin/order-list',
        'attachment-storage': '/admin/attachment-storage',
        'attachment-download': '/admin/download-management',
        'attachment-email': '/admin/attachment-email',
        'admin-setting': '/admin/admin-setting',
        'admin-add': '/admin/admin-add',
        'admin-permission': '/admin/admin-permission',
        'ad-setting': '/admin/ad-setting',
        'generate-history': '/admin/generate-history'
      }

      if (routeMap[key]) {
        this.$router.push(routeMap[key])
      }
    },
    logout() {
      // 清除token
      localStorage.removeItem('token')
      // 跳转到登录页面
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
  background: #0d0f16;
  display: flex;
  flex-direction: column;
}

.admin-header {
  background: #0b0e17;
  color: #fff;
  padding: 0 24px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.admin-header h1 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #00e6ac;
}

.admin-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-logout {
  padding: 6px 12px;
  background: #222;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-logout:hover {
  background: #333;
}

.admin-body {
  flex: 1;
  display: flex;
  min-height: 0;
}

.admin-sidebar {
  width: 200px;
  background: #0b0e17;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  overflow-y: auto;
}

.admin-sidebar .el-menu {
  background: transparent;
  border-right: none;
}

.admin-sidebar .el-menu-item {
  color: #ccc;
  height: 48px;
  line-height: 48px;
  margin: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.admin-sidebar .el-menu-item:hover {
  background: rgba(0, 230, 172, 0.1);
  color: #00e6ac;
}

.admin-sidebar .el-menu-item.is-active {
  background: rgba(0, 230, 172, 0.2);
  color: #00e6ac;
  border-right: 3px solid #00e6ac;
}

.admin-sidebar .el-submenu__title {
  color: #ccc;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.admin-sidebar .el-submenu__title:hover {
  background: rgba(0, 230, 172, 0.1);
  color: #00e6ac;
}

.admin-content {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  min-height: calc(100vh - 60px);
  height: auto;
  width: 100%;
}

/* 滚动条样式 */
.admin-sidebar::-webkit-scrollbar {
  width: 6px;
}

.admin-sidebar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.admin-sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.admin-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

.admin-content::-webkit-scrollbar {
  width: 8px;
}

.admin-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.admin-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.admin-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 响应式 */
@media (max-width: 768px) {
  .admin-sidebar {
    width: 180px;
  }

  .admin-content {
    padding: 16px;
  }
}
</style>
